import { Backdrop, CircularProgress } from '@mui/material';
import { PinDropSharp } from '@material-ui/icons';
import { useEffect } from 'react';
import { useUserState } from '../../../context/UserContext';

const Loading = (props) => {
  const { authenticationInProcess } = useUserState();
  const {isLoading} = props;
  useEffect( ()=>{
      console.log('Authentication in process:', authenticationInProcess);
  },[authenticationInProcess]);
  useEffect ( ()=>{
    console.log('isLoading:', isLoading);
  },[]);
  return (
    <Backdrop
        open={authenticationInProcess || isLoading}
        //open={true}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 999 }}
    >
      <CircularProgress sx={{ color: 'inherit' }} />
    </Backdrop>
  );
};

export default Loading;
